import script from "./MonthDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./MonthDialog.vue?vue&type=script&setup=true&lang=ts"

import "./MonthDialog.vue?vue&type=style&index=0&id=885de978&lang=scss"

const __exports__ = script;

export default __exports__